export default "__VITE_ASSET__DOmjLsC8__"